export const ParseFileModal: string = 'ParseFileModal';
